import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const useAccountingBookSummary =  (authState) => {
  const { group_id, accounting_book_id } = useParams();
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(true);
  const [summary, setSummary] = useState([]);
  const [settlements, setSettlements] = useState([])
  const [currentUserDebt, setCurrentUserDebt] = useState(0)

  const getAccountingBook = async () => {
    setLoading(true)
    await authState.api.getAccountingBookSummary(group_id, accounting_book_id)
      .then(function (response) {
        setCurrentUserDebt(response.data.current_user_debt)
        setSettlements(response.data.settlements)
        setSummary(response.data.transactions)
      })
      .catch(function (error) {
        setErr(error);
      })
    setLoading(false)
  }

  useEffect(() => {
    if (authState && authState.api) {
      getAccountingBook();
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [authState])

  return [summary, loading, err, getAccountingBook, currentUserDebt, settlements];
}

export default useAccountingBookSummary;
